import React from 'react';
import './Marcas.css';
const Img1 = 'https://cdn.nudus.app/Images/marcas/1.png';
const Img2 = 'https://cdn.nudus.app/Images/marcas/2.png';
const Img3 = 'https://cdn.nudus.app/Images/marcas/3.png';
const Img4 = 'https://cdn.nudus.app/Images/marcas/4.png';
const Img5 = 'https://cdn.nudus.app/Images/marcas/5.png';
const Img6 = 'https://cdn.nudus.app/Images/marcas/6.svg';
const Img7 = 'https://cdn.nudus.app/Images/marcas/7.png';
const Img8 = 'https://cdn.nudus.app/Images/marcas/8.png';
const Img9 = 'https://cdn.nudus.app/Images/marcas/9.png';
const Img10 = 'https://cdn.nudus.app/Images/marcas/10.png';
const Img11 = 'https://cdn.nudus.app/Images/marcas/11.png';
const Img12 = 'https://cdn.nudus.app/Images/marcas/12.png';
const Img13 = 'https://cdn.nudus.app/Images/marcas/13.png';
const Img14 = 'https://cdn.nudus.app/Images/marcas/14.png';
const Img15 = 'https://cdn.nudus.app/Images/marcas/15.png';
const Img16 = 'https://cdn.nudus.app/Images/marcas/16.png';
const Img17 = 'https://cdn.nudus.app/Images/marcas/17.png';
const Img18 = 'https://cdn.nudus.app/Images/marcas/18.png';
const Img19 = 'https://cdn.nudus.app/Images/marcas/19.png';
const Img20 = 'https://cdn.nudus.app/Images/marcas/20.png';
const Img21 = 'https://cdn.nudus.app/Images/marcas/21.png';
const Img22 = 'https://cdn.nudus.app/Images/marcas/22.png';
const Img23 = 'https://cdn.nudus.app/Images/marcas/23.png';
const Img24 = 'https://cdn.nudus.app/Images/marcas/24.png';

const images = [
  Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8,
  Img9, Img10, Img11, Img12, Img13, Img14, Img15, Img16,
  Img17, Img18, Img19, Img20, Img21, Img22, Img23, Img24
];

const MarcasSlider = () => {
  const half = Math.ceil(images.length / 2);
  const firstRow = images.slice(0, half);
  const secondRow = images.slice(half);

  return (
    <div className='slider-marcas-container'> 
      <div className='home-tittles'>
        <h3>Marcas que confían en nosotros</h3>
        <hr/>
      </div>
      
      <div className='marcas-carousel'>
        <div className='marcas-row'>
          {[...firstRow, ...firstRow].map((img, i) => (
            <div key={`row1-${i}`} className='marcas-item'>
              <img src={img} alt={`marca${i + 1}`} />
            </div>
          ))}
        </div>

        <div className='marcas-row'>
          {[...secondRow, ...secondRow].map((img, i) => (
            <div key={`row2-${i}`} className='marcas-item'>
              <img src={img} alt={`marca${i + 1 + half}`} />
            </div>
          ))}
        </div>
      </div>

      <div className='knauf-section'>
        <h4>Distribuidores oficiales de</h4>
        <div className='knauf-section-img'>
          <a href='https://www.knauf.com.ar' rel='noreferrer' target='_blank'><img alt='knauf' src={Img6}/></a>
          <a href='https://www.faplaconline.com.ar/home/' rel='noreferrer' target='_blank'><img alt='faplac' src={Img13}/></a>
        </div>
      </div>
    </div>
  );
};

export default MarcasSlider;